import * as React from 'react';

import { MobilePage } from '../../components/MobilePage';

export const MobilePageContainer: React.FC<{}> = () => {
  return <MobilePage />;
};
